import { Character, NodeType, SerializedContent } from '@storyverse/shared'
import { characterRepository } from '../repository/CharacterRepository'

export class CharacterService {
    async getCharacters(projectId: string): Promise<Character[]> {
        return characterRepository.getByProjectId(projectId)
    }

    async saveCharacter(character: Character): Promise<Character> {
        return characterRepository.saveCharacter(character)
    }

    async deleteCharacter(id: string): Promise<void> {
        await characterRepository.deleteCharacter(id)
    }

    /**
     * Simple client-side character extraction from screenplay content
     */
    extractCharactersFromScreenplay(content: SerializedContent[], projectId: string): Character[] {
        const characterNames = new Set<string>()

        content.forEach(node => {
            if (node.type === NodeType.Character) {
                const name = node.children?.[0]?.text?.trim().toUpperCase()
                if (name) characterNames.add(name)
            }
        })

        return Array.from(characterNames).map(name => ({
            id: crypto.randomUUID(),
            projectId,
            name,
            role: 'Support', // Default role
            created_at: new Date(),
            updated_at: new Date()
        }))
    }
}

export const characterService = new CharacterService()
